/** @todo contribute these to @types/rocketchat and require */

export interface IMessage {
  rid: string | null, // room ID
  _id?: string, // generated by Random.id()
  t?: string, // type, e.g. rm
  msg?: string, // text content
  alias?: string, // ??
  emoji?: string, // emoji code
  avatar?: string, // url
  groupable?: boolean, // ?
  bot?: any, // integration details
  urls?: string[], // ?
  mentions?: string[], // ?
  reactions?: { [emoji: string]: string[] } // emoji: [usernames]
  location?: {
    type: string, // e.g. Point
    coordinates: string[] // longitude, latitude
  },
  attachments?: IAttachment[],
  editedAt?: Date,
  editedBy?: {
    _id: string,
    username: string
  }
}

export interface IAttachment {
  fields: IAttachmentField[],
  color?: string,
  text?: string,
  ts?: string,
  thumb_url?: string,
  message_link?: string,
  collapsed?: boolean,
  author_name?: string,
  author_link?: string,
  author_icon?: string,
  title?: string,
  title_link?: string,
  title_link_download?: string,
  image_url?: string,
  audio_url?: string,
  video_url?: string
}

export interface IAttachmentField {
  short?: boolean,
  title: 'string',
  value: 'string'
}
